import React from "react";

import Headline from "headline";
import Button from "button";

const SuspendedPurchases = () => {
  return (
    <>
      <Headline h5 left html="Orders have been suspended" />
      <Headline
        reg
        h6
        el="p"
        html="We're temporarily not taking any new orders due to a technical issue, please come back in a few minutes. Get notified when we're back by clicking the button below."
      />
      <Button small onClick={() => console.log("Heeey!")}>
        Accept notifications
      </Button>
    </>
  );
};

export default SuspendedPurchases;
